import type { Language } from '@/types';
import { getTranslation } from '@/utils/translations';

// Service commun de réception des formulaires de devmeup (dépôt devmeup-fr/forms-relay).
// Il vérifie l'origine, le champ piège et le jeton Turnstile, puis envoie le message à contact@devmeup.fr.
const FORMS_ENDPOINT = 'https://forms.devmeup.fr/s/devmeup';

// Codes d'erreur renvoyés par le service, avec le message à afficher.
const ERROR_MESSAGES: Record<string, string> = {
  captcha_failed: 'form.error.captcha',
  invalid_fields: 'form.error.fields',
  rate_limited: 'form.error.rateLimited',
};

class EmailService {
  // Envoie les champs du formulaire tels quels : name, email, phone, company, message,
  // ainsi que le champ piège « website » et le jeton « cf-turnstile-response » ajouté par Turnstile.
  async sendEmail(
    formData: FormData,
    language: Language = 'fr'
  ): Promise<{ success: boolean; message: string }> {
    try {
      const response = await fetch(FORMS_ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      const result = (await response.json().catch(() => ({}))) as { ok?: boolean; error?: string };

      if (response.ok && result.ok) {
        return {
          success: true,
          message: getTranslation(language, 'form.success.message'),
        };
      }
      return {
        success: false,
        message: getTranslation(language, ERROR_MESSAGES[result.error ?? ''] ?? 'form.error.submit'),
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Form sending error:', error);
      return {
        success: false,
        message: getTranslation(language, 'form.error.network'),
      };
    }
  }
}

export default EmailService;
